import { render } from "./FormPayment.vue?vue&type=template&id=6eccf051&ts=true"
import script from "./FormPayment.vue?vue&type=script&lang=ts"
export * from "./FormPayment.vue?vue&type=script&lang=ts"

import "./FormPayment.vue?vue&type=style&index=0&id=6eccf051&lang=scss"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__